const accordion = (() => {
  const defaultAccordion = () => {
    const accordionItem = document.getElementsByClassName('js-trigger-accordion');

    for (let i = 0; i < accordionItem.length; i += 1) {
      accordionItem[i].addEventListener('click', function (event) {
        event.currentTarget.classList.toggle('js-active');
        const accordionContent = this.nextElementSibling;
        accordionContent.classList.toggle('js-active');
      });
    }
  };

  const defaultAccordionContainer = () => {
    const accordionItem = document.getElementsByClassName('js-trigger-accordion-container');

    for (let i = 0; i < accordionItem.length; i += 1) {
      accordionItem[i].addEventListener('click', function (event) {
        const clickedItem = event.currentTarget;
        
        // Tüm accordion itemları kapat
        for (let j = 0; j < accordionItem.length; j += 1) {
          accordionItem[j].classList.remove('js-active');
        }
        
        // Tıklanan item'ı aç (eğer zaten açık değilse)
        if (!clickedItem.classList.contains('js-active')) {
          clickedItem.classList.add('js-active');
        }
      });
    }
  };

  const init = () => {
    defaultAccordion();
    defaultAccordionContainer();
  };

  return {
    init,
  };
})();

export default accordion;
